import { Spinner } from '@leroy-merlin-br/backyard-react'

import * as S from './styled'

const InputLoading = ({ children, isLoading }) => (
  <S.WrapperField>
    {children}

    {isLoading && (
      <S.WrapperLoading>
        <Spinner size="giga" appearance="info" />
      </S.WrapperLoading>
    )}
  </S.WrapperField>
)

export default InputLoading
